/**
 * Public env accessors for the admin Vite app.
 *
 * VITE_* values are embedded in browser code. Never put server secrets in
 * these variables.
 */
export const getPublicApiUrl = (): string | undefined =>
  import.meta.env.VITE_API_URL;

export const getPublicConfigFlavor = (): string | undefined =>
  import.meta.env.VITE_CONFIG_FLAVOR;

/** Optional local/CI override for Persondata report-text generation (issues/003). */
export const getPublicEnablePersondataReportTextGeneration = ():
  | boolean
  | undefined => {
  const raw = import.meta.env.VITE_ENABLE_PERSONDATA_REPORT_TEXT_GENERATION;
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return undefined;
};
